/**
 * Table des routes de la console : chemin, écran et rôles autorisés.
 *
 * Les écrans du menu et leurs onglets viennent de `config/sections`
 * (`construireRoutes`). Restent déclarées ici les fiches de détail ouvertes
 * depuis une liste, le profil et la page « non autorisé ».
 *
 * Une route sans `roles` est ouverte à tout compte back-office (RoleGate
 * refuse déjà les comptes sans rôle) ; avec `roles`, App l'enveloppe dans
 * `ProtectedRoute`.
 */
import React from 'react';
import { UserRole } from '../types/rbac';
import { SECTIONS } from '../config/sections';
import { construireRoutes } from './routesDesSections';
import LeconAdvancedEditor from '../components/lecons/LeconAdvancedEditor';
import LeconView from '../components/lecons/LeconView';
import ExerciceAdvancedEditor from '../components/exercices/ExerciceAdvancedEditor';
import ExerciceView from '../components/exercices/ExerciceView';
import ChapitreView from '../components/chapitres/ChapitreView';
import MatiereView from '../components/matieres/MatiereView';
import ClasseView from '../components/classes/ClasseView';
import VideoView from '../components/videos/VideoView';
import SchoolBookView from '../components/school-books/SchoolBookView';
import BookChapterView from '../components/school-books/BookChapterView';
import BookLessonView from '../components/school-books/BookLessonView';
import BookExerciseView from '../components/school-books/BookExerciseView';
import UnauthorizedPage from '../pages/UnauthorizedPage';
import ProfilePage from '../pages/ProfilePage';
/** Une route de la console. */
export interface AppRoute {
  path: string;
  element: React.ReactElement;
  /** Rôles autorisés (absent : tout compte back-office). */
  roles?: UserRole[];
}

/** Fiches de détail du contenu : ouvertes depuis les listes (lot 2 : panneau latéral). */
const ROUTES_DE_DETAIL: AppRoute[] = [
  { path: '/classes/:id', element: <ClasseView /> },
  { path: '/matieres/:id', element: <MatiereView /> },
  { path: '/chapitres/:id', element: <ChapitreView /> },
  { path: '/lecons/:id', element: <LeconView /> },
  { path: '/lecons/:id/edit-advanced', element: <LeconAdvancedEditor /> },
  { path: '/exercices/:id', element: <ExerciceView /> },
  { path: '/exercices/:id/edit-advanced', element: <ExerciceAdvancedEditor /> },
  { path: '/videos/:id', element: <VideoView /> },
  { path: '/school-books/:id', element: <SchoolBookView /> },
  { path: '/book-chapters/:id', element: <BookChapterView /> },
  { path: '/book-lessons/:id', element: <BookLessonView /> },
  { path: '/book-exercises/:id', element: <BookExerciseView /> },
];

export const APP_ROUTES: AppRoute[] = [
  ...construireRoutes(SECTIONS),
  ...ROUTES_DE_DETAIL,
  { path: '/unauthorized', element: <UnauthorizedPage /> },
  { path: '/profile', element: <ProfilePage /> },
];
